<app-kontable
        id="dt_classification_details"
        title = "{{ 'common.classification_details_title' | translate }}"
        [columns] = "['id', 'code', 'description']"
        [titles] = "['common.id', 'common.code', 'common.description']"
        [showInfoButton]="false"
        [showRecoverButton]="false"
        [showGlobalFilter]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [konPermissions]="perm"
        [source]="svc.details"
        (onAdd)="showAddDialog($event)"
        (onEdit)="onEditInline($event)"
        (onRemove)="onDeleteInline($event)">
</app-kontable>

<p-dialog
        *ngIf="svc.editingDetail"
        [width]="600"
        header="{{modalTitle}}"
        [(visible)]="svc.editingDetail"
        [responsive]="true"
        showEffect="fade"
        [modal]="true"
        (onHide)="onDialogHide()">
    <app-common-classification-details-form
            [editingElement]="svc.editingDetail"
            (onAddElement)="onAdd($event)">
    </app-common-classification-details-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/classification/classification-details/classification-details.component.html